import { Injectable } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { map, mapTo } from 'rxjs/operators';
import { Service } from '../_models/service'
import { LocaleService } from '../_services/locale.service';

@Injectable({
    providedIn: 'root'
})
export class ServicesDataProvider {
    private services: Service[] = [];
    private orphans: Service[] = [];
    private translatedServices: Service[] = [];
    private translatedOrphanServices: Service[] = [];

    constructor(
        private localeService: LocaleService
    ) { }

    setServices(services: Service[]) {
        if (!Array.isArray(services)) {
            this.services = [];
        } else {
            this.services = services;
        }
        return this;
    }


    addService(service: Service) {
        this.services.push(service);
        return this;
    }

    addServices(services: Service[]) {
        this.services = this.services.concat(services);
        return this;
    }

    getServices() {
        return this.services;
    }

    getService(id: number) {
        if (this.services.length == 0) {
            return;
        }
        return this.services.find( service => service.id === id );
    }

    getTranslatedServices() {
        this.translatedServices = [];
        if (!Array.isArray(this.services)) {
            return [];
        } else {
            this.services.forEach(service => {
                const translatedService = this.translateService(service);
                if (translatedService) {
                    this.translatedServices.push(translatedService);
                }
            })
        }

        return this.translatedServices;
    }

    getTranslatedService(id: number) {
        if (this.services.length == 0) {
            return;
        }
        return this.translateService(this.getService(id));
    }

    private translateService(service: Service) {
        if (!service) {
            return;
        }

        let translatedService = {...service};
        let locale = this.localeService.getLocale();
        if (Array.isArray(translatedService.translations) && translatedService.translations.length > 0) {
            let localeTranslation: any = translatedService.translations.find( (translation: any) => translation.locale === locale );
            if (localeTranslation) {
                translatedService.name = localeTranslation.name;
                translatedService.description = localeTranslation.description;
            }
        }
        return translatedService;
    }

    setOrphanServices (orphans: Service[]) {
        if (!Array.isArray(orphans)) {
            this.orphans = [];
        } else {
            this.orphans = orphans;
        }
        return this;
    }

    getOrphanServices() {
        return this.orphans;
    }

    getOrphanTranslatedServices() {
        this.translatedOrphanServices = [];
        if (!Array.isArray(this.orphans)) {
            return [];
        }

        this.orphans.forEach(service => {
            const translatedService = this.translateService(service);
            if (translatedService) {
                this.translatedOrphanServices.push(translatedService);
            }
        });
        return this.translatedOrphanServices;
    }
}
